<script setup>

import CheckBox from "@/components/ai-onboarding/partials/CheckBox.vue";
import {computed} from "vue";
import DifficultyTag from "@/components/ai-onboarding/partials/DifficultyTag.vue";

const props = defineProps({
  aiKeyword: {
    type: Object,
    required: true,
  },
  checked: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:checked']);

const handleClick = () => {
  emit('update:checked', !props.checked);
};

const variantClassMap = {
  blue: 'tw-bg-gradient-to-b tw-from-blueGradientStart tw-to-blueGradientEnd tw-border-t tw-border-blue',
  grey: 'tw-bg-gradient-to-b tw-from-greyGradientStart tw-to-greyGradientEnd tw-border-t tw-border-grey',
};

const classMap = computed(() => {
 return props.checked ? variantClassMap.blue : variantClassMap.grey;
});
</script>

<template>
  <div
    :class="[
      'tw-grid tw-grid-cols-12 tw-w-full flex-shrink-0 tw-py-3 tw-pl-8 tw-cursor-pointer tw-items-center',
      classMap,
    ]"
    @click="handleClick"
  >
    <div class="tw-col-span-6 tw-flex tw-items-center tw-gap-6">
      <svg-vue
        icon="icons/sparkles-outline"
        class="tw-w-6 tw-h-6 tw-text-blue tw-shrink-0"
      />

      <span class="tw-text-grey-dark tw-text-base tw-font-bold tw-text-left">
        {{ aiKeyword.keyword_index.keyword }}
      </span>
    </div>

    <div class="tw-col-span-2 tw-text-center">
      <DifficultyTag :difficulty="aiKeyword.keyword_index.difficulty" />
    </div>

    <div class="tw-col-span-2 tw-text-grey-dark tw-text-center tw-font-bold tw-text-lg">
      {{ aiKeyword.keyword_index.search_volume > 0 ? aiKeyword.keyword_index.search_volume.toLocaleString() : '< 10' }}
    </div>

    <div class="tw-col-span-2 tw-flex tw-justify-center">
      <CheckBox
        class="tw-w-8 tw-h-8"
        :class="{
          '!tw-border-grey': !checked,
        }"
        :model-value="checked"
        variant="blue"
        @update:model-value="handleClick"
      />
    </div>
  </div>
</template>
